import { render, staticRenderFns } from "./viewChild.vue?vue&type=template&id=a6b978f6&"
import script from "./viewChild.vue?vue&type=script&lang=js&"
export * from "./viewChild.vue?vue&type=script&lang=js&"
import style0 from "./viewChild.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports